import { Post } from "../api/server";

export default function trackingLink(event, aff) {
  return Post(`/affiliatetrackings`, {
    event: event,
    aff: aff
  })
  .then((res) => res)
  .catch((err) => err);
}